<template>
    <div class="artists">
        <div class="row">
            <div class="column">
                <div class="container" @click="showModal('bestialMouths')">
                    <img class="artist" src="../assets/artists/Bestial-Mouths-no-logo.jpg">
                </div>
            </div>
            <div class="column">
                <div class="container" @click="showModal('cryo')">
                    <img class="artist" src="../assets/artists/Cryo-no-logo.jpg">
                </div>
            </div>
            <div class="column">
                <div class="container" @click="showModal('wychdoktor')">
                    <img class="artist" src="../assets/artists/Wychdoktor-no-logo.jpg">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="column">
                <div class="container" @click="showModal('veliuNamai')">
                    <img class="artist" src="../assets/artists/Veliu-Namai-no-logo.jpg">
                </div>
            </div>
            <div class="column">
                <div class="container" @click="showModal('lolaKumtus')">
                    <img class="artist" src="../assets/artists/Lola-Kumtus-no-logo.jpg">
                </div>
            </div>
            <div class="column">
                <div class="container" @click="showModal('plasticWhore')">
                    <img class="artist" src="../assets/artists/Plastic-Whore-no-logo.jpg">
                </div>
            </div>
            <div class="column">
                <div class="container" @click="showModal('kirurg')">
                    <img class="artist" src="../assets/artists/Kirurg-no-logo.jpg">
                </div>
            </div>
        </div>
        <modal v-if="displayModal" :style="modalStyle" @close="closeModal">
            <div slot="header">{{ selectedArtist.name }}</div>
            <div slot="body"> {{ selectedArtist.text }}
                <div slot="video" v-if="selectedArtist.youtube !== ''">
                    <iframe class="iframe"
                            :src="selectedArtist.youtube"
                            frameborder="0"
                            allowfullscreen>
                    </iframe>
                </div>
                <div class="links">
                    <a v-if="selectedArtist.facebook !== ''" :href="selectedArtist.facebook" target="_blank">FACEBOOK</a>
                    <a :href="selectedArtist.bandcamp" target="_blank">BANDCAMP</a>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import Modal from './Modal'
    import artists from '../artists'

    export default {
        name: 'Artists',
        components: {Modal},
        data() {
            return {
                displayModal: false,
                selectedArtist: {},
            }
        },
        methods: {
            showModal(artistName) {
                this.selectedArtist = artists[artistName]
                this.displayModal = true
                this.modalStyle()
            },
            closeModal() {
                this.displayModal = false
                this.modalStyle()
            },
            modalStyle() {
                if (this.displayModal) {
                    return 'display: flex;'
                } else return 'display: none;'
            }
        }
    }
</script>

<style scoped>
    .artists {
        margin: 0 auto;
        width: 100%;
        background-color: #cdcdcd;
    }

    h2 {
        padding: 60px 0 40px;
        color: #c99c27;
        font-family: 'Tw Cen MT', 'Champagne-Limousines-Thick', 'Apple Gothic', 'URW Gothic L', 'Avant Garde', 'Futura';
    }

    .artist {
        width: 100%;
    }

    .row {
        display: flex;
        padding: 10px;
    }

    @media (max-width: 425px) {
        .row {
            flex-direction: column;
            padding: 5px;
        }
    }

    .row:first-child {
        padding-bottom: 0;
    }

    .links {
        margin: 30px 0 20px 0;
    }

    a {
        font-size: 14px;
        color: #031D24;
        display: flex;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        letter-spacing: 2px;
        margin: 10px;
    }

    .column {
        flex: 33.33%;
        padding: 10px;
    }

    .container {
        cursor: pointer;
        position: relative;
    }

    .iframe {
        margin-top: 30px;
        width: 100%;
        min-height: 350px;
    }

    @media (max-width: 425px) {
        .iframe {
            width: 100%;
            height: 100%;
        }
    }

</style>